import React, { useRef } from 'react';
import classNames from 'classnames';

import { Arrow } from '@/icons/index';
import useOnClickOutside from '@/hooks/useClickOutside';

import Input from '../Input/Input';

import styles from './InputWithSelect.module.scss';

export default function InputWithSelect({
  label = '',
  placeholder = '',
  options = [],
  onSelect = () => null,
  onChange = () => null,
  className,
  selected,
  value,
  ...props
}) {
  const [isListShown, setIsListShown] = React.useState(false);
  const listRef = useRef(null);
  const toggleRef = useRef(null);
  const renderOptions = (item, key) => {
    const handleSelect = () => {
      onSelect(item);
      setIsListShown(false);
    };
    return (
      <li key={key} onClick={handleSelect}>
        {item.name}
      </li>
    );
  };

  const onClose = () => {
    setIsListShown((prev) => !prev);
  };

  useOnClickOutside(listRef, (event) => {
    if (toggleRef.current && toggleRef.current.contains(event.target)) {
      return;
    }
    if (isListShown) {
      setIsListShown(false);
    }
  });

  return (
    <div
      className={classNames([
        styles.searchSelect,
        { [styles.searchSelect__selectActive]: isListShown },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Thing'
    >
      <div ref={toggleRef} onClick={onClose} className={styles.list}>
        <span className={styles.value}>
          {selected} <Arrow width={18} />
        </span>
      </div>
      <ul ref={listRef} className={styles.selectList}>
        {!!options.length && options.map(renderOptions)}
      </ul>

      <Input
        className={styles.input}
        label={label}
        type='text'
        value={value}
        onFocus={() => setIsListShown(false)}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
    </div>
  );
}
